var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.37886C4 9.05363 4.15816 8.74872 4.42401 8.5614L11.424 3.62915C11.7694 3.38576 12.2306 3.38576 12.576 3.62915L19.576 8.5614C19.8418 8.74872 20 9.05363 20 9.37886V20C20 20.5523 19.5523 21 19 21H5C4.44771 21 4 20.5523 4 20V9.37886Z",
    stroke: "#1B1E28",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15H13ZM13 20V15H11V20H13Z",
    fill: "#1B1E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroHome);
export default __webpack_public_path__ + "static/media/introHome.2b3fa2023a0a0d6f1943199e83389853.svg";
export { ForwardRef as ReactComponent };